import type { Col } from '../sim/types';

export type WorldHighlight = { kind: 'tile'; col: Col } | { kind: 'building'; buildingId: number };

/**
 * UI-side requests for world-space attention pulses. The tutorial (or any
 * future guide) rewrites the list each frame; the renderer only reads it.
 * Keeps the render layers ignorant of the tutorial and vice versa.
 */
export class AttentionBus {
  highlights: readonly WorldHighlight[] = [];

  set(highlights: readonly WorldHighlight[]): void {
    this.highlights = highlights;
  }

  clear(): void {
    this.highlights = [];
  }
}
